module.exports = __webpack_public_path__ + "static/media/css.0a9813fc.svg";